import { render, staticRenderFns } from "./setNumCompute.vue?vue&type=template&id=55436f60&"
import script from "./setNumCompute.vue?vue&type=script&lang=js&"
export * from "./setNumCompute.vue?vue&type=script&lang=js&"
import style0 from "./setNumCompute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports